import React, { Component } from 'react'
import  {Segment, Container}  from 'semantic-ui-react'

class Home extends Component {
    constructor(props) {
        super(props);
        this.state = {}
    }

    componentWillMount() {

    }

    render() {

    return (
        <Container>
            <Segment>Bienvenue sur la page d'accueil</Segment>
        </Container>
        )
    }
}

export default Home


// WEBPACK FOOTER //
// ./src/components/Protected/Home.jsx